import React from 'react';
import { createClasses } from '@kp/react-ui';
import { Color } from '../../constants/Colors';

const classes = createClasses({
  root: {
    display: 'flex',
  },
  content: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: Color.contentBackground,
  },
});
type LayoutSimpleProps = { children?: React.ReactNode };
export const LayoutSimple: React.FC<LayoutSimpleProps> = ({ children }) => {
  return (
    <div className={classes.root}>
      <div className={classes.content}>{children}</div>
    </div>
  );
};
